import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { DepartmentActions } from '../State/actions/department.actions';
import { getDepartmentFetched, getDepartmentLatestUpdatedAt } from '../State/selectors/department.selector';
import { BaseEntityReloadResolver2 } from './resolver.helper';
import { GetTimestampFromTime } from "@dave/types";

@Injectable({
    providedIn: 'root',
})
export class DepartmentResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getDepartmentFetched, getDepartmentLatestUpdatedAt, DepartmentActions.loadRequest, store, (d) => GetTimestampFromTime(d)+'');
    }
}
